export const QA_NAME_SELECT_ALL_BTN = 'selectAll'

export const QA_DELETE_SELECT_ALL_BTN = 'deleteSelectAll'
